import { IkeToken, type CollectionSummaryJSONObject, type TagJSONObject } from '@ikegps/core-api';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import type { TagState } from '../../page/tag.state';
import { Services } from '../../services';
import { VariantLayerState } from '../../state/variant.layer.state';
import { CollectionCard } from './collection.card';
import { CSS, Style } from './collection.list.style';
import { hasCollectionVariants } from './collection.variant.group';
import { VariantContainer } from './variant.container';

addStyles(Style);

export const CollectionList = {
	view(
		state: TagState,
		tag: TagJSONObject,
		collectionSummaries: CollectionSummaryJSONObject[],
		header?: MithrilVNode
	): MithrilVNode {
		const collectionCards: MithrilVNode[] = [];
		const showVariants = Services.Token.has(IkeToken.FEATURE_COLLECTION_VARIANTS);

		// Three states, driven by the tokens:
		//  - layer UI active (selector shown): the list is flat and layer-filtered.
		//  - feature on but no selector on this surface (e.g. /map without the big-map token): the legacy
		//    nested "Existing -> variants" accordion (VariantContainer, UFO-776).
		//  - feature off: variants are hidden entirely — base poles render as plain cards, no nesting.
		const useLayers = state.layersActive(tag.objectId);
		const nestVariants = showVariants && VariantLayerState.featureEnabled() && !useLayers;

		for (const collectionSummary of collectionSummaries) {
			const summaryView =
				nestVariants && hasCollectionVariants(collectionSummary)
					? VariantContainer.view(state, tag, collectionSummary)
					: CollectionCard.view(state, tag, collectionSummary);
			collectionCards.push(summaryView);
		}

		// `header` (the variant layer selector on PhotoMeasure) rides at the top of the list itself.
		return m('div', { className: CSS.container, key: 'cl-' + tag.objectId }, [header ?? null, ...collectionCards]);
	},

	viewLoading(tagId: string) {
		return m('div', { className: `${CSS.container} ${CSS.loading}`, key: 'cl-' + tagId }, Spinner.view());
	},
};
